import { v5 as uuidv5 } from 'uuid';

/**
 * Nula workspace namespace UUID — used with UUID v5 to derive deterministic
 * workspace doc IDs from user provider IDs. Must match the server-side constant
 * in apps/api/src/utils.rs.
 */
const WORKSPACE_NAMESPACE = '7a3f4b2e-1d5c-4e8a-9f0b-6c2d3e4f5a6b';

/** Derive a deterministic workspace doc UUID from a user's provider ID (Clerk sub). */
export function workspaceDocId(providerSub: string): string {
  return uuidv5(`workspace:${providerSub}`, WORKSPACE_NAMESPACE);
}
